import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import {
  REPORT_TYPES,
  TWITTERLEGENDS,
  INSIGHTLEGENDS,
  SOCIAL_SOURCES,
  INSTAINSIGHTLEGENDS,
  LOGO
} from "../../../../constants/app-constant";
import { getInlineFilterText, getSocialPlatformIdFromName, getTimelineText, getTimelineTextPosition } from "../../../../utility/common-methods";

const {
  JournalistNOARanking,
  JournalistAnalysisPrint,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
  PLATFORM_RANK,
  Reach,
  TonalityNAOTrend,
  StateWiseTrend,
  JournalistWCRanking,
  TonalityWordCount,
  TonalityWCTrend,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
  ShareRetweet,
  ReplyComment,
  Attachment,
  Like,
  MemberType,
  TypeOfPost,
  TopPostersTrend,
  InfluencerWithDetail
} = REPORT_TYPES;
const formatTwitterData = (data) => {
  if (!data) return;
  return TWITTERLEGENDS.map(({ name, color, entityname }) => {
    const newArray = data.map((x) => {
      const array = Object.keys(x).filter((el, index) => el == entityname);
      return parseInt(x[array]);
    });
    return {
      name: name,
      data: newArray,
      color: color,
    };
  });
};
const formatInsightData = (data,insightData) => {
  if (!data) return;
  if(insightData === SOCIAL_SOURCES.INSTAGRAM){
    return INSTAINSIGHTLEGENDS.map(({ name, color, entityname }) => {
      const newArray = data.map((x) => {
        const array = Object.keys(x).filter((el, index) => el == entityname);
        return parseInt(x[array]);
      });
      return {
        name: name,
        data: newArray,
        color: color,
      };
    });
  }
  else{
    return INSIGHTLEGENDS.map(({ name, color, entityname }) => {
      const newArray = data.map((x) => {
        const array = Object.keys(x).filter((el, index) => el == entityname);
        return parseInt(x[array]);
      });
      return {
        name: name,
        data: newArray,
        color: color,
      };
    });
  }
};

const formatMetricData = (data) => {
    if (!data && !data.length) return;
  return data.map(({ users }) => parseInt(users));
};

const formatInsightMetricData = (data) => {
  if (!data && !data.length) return;
  return data.map(({ users }) => parseInt(users));
};

const x_lables = (data) => {
    if (!data) return;
  return data.map((elm) => elm.date);
};
const formatData = ({ datasets }) => {
    if (!datasets) return;
  return datasets
    .map((elm) => ({
      name: elm.label,
      data: elm.data && elm.data.map((el) => parseInt(el, 10)),
      color: elm.backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};
export const LineChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  twitterFeeds,
  insightFeeds = 0,
  type,
  selectedFilter,
  metricsData,
  fromUserName="",
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  const ref = useRef();
  const [lineChartData, setLineChartData] = useState({});
  const metricsGraphData = [
    {
      name: "",
      data: metricsData && type === "linkedinKeymetrics"?formatInsightMetricData(metricsData):(metricsData && formatMetricData(metricsData)),
      color: "#E96F6F",
    },
  ];

  useEffect(() => {
    twitterFeeds && redrawChart();
    insightFeeds !== 0 && insightFeeds !== undefined && redrawChart();
    setGraphRef(ref);
  }, [data, metricsData]);

  useEffect(() => {
    Object.keys(graphApiResponse).length && !twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) && redrawChart();
  }, [graphApiResponse]);

  const showLegends = (twitterFeeds && type === "twitterKeymetrics") || (insightFeeds !== 0 && insightFeeds !== undefined && type == "linkedinKeymetrics");

  const redrawChart = () => {
    // const labels = (twitterFeeds || insightFeeds !== 0)
    const labels = (twitterFeeds  || (insightFeeds !== 0 && insightFeeds !== undefined))
      ? (type === "twitterKeymetrics" || type == "linkedinKeymetrics")
        ? x_lables(metricsData)
        : x_lables(data)
      : graphApiResponse.labels;
    const options = {
      chart: {
        type: "line",
        animation: false,
      },
      legend: {
        enabled: !showLegends,
        maxHeight: 65,
      },
      title: {
        text: fromUserName+" "+chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          chart: {
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText(to_date,from_date,dateHash)}`,
                    getTimelineTextPosition(getTimelineText(to_date,from_date,dateHash)),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)} `,
                    getTimelineTextPosition(getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
      series: twitterFeeds
        ? (type === "twitter"
          ? formatTwitterData(data)
          : metricsGraphData)
        : (insightFeeds !== 0 && insightFeeds !== undefined?(type === "linkedinKeymetrics"?metricsGraphData:formatInsightData(data,insightFeeds)):formatData(graphApiResponse)),
      plotOptions: {
        line: {
          marker: {
            symbol: "circle",
          },
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          label: {
            connectorAllowed: false,
          },
          events: {
            click: (e) => handlePointsClick(e),
          },
        },
      },
      xAxis: {
        tickmarkPlacement: "on",
        // min: 1.0,
        // max: labels.length - 2.0, Removed due to 2 data removed directly
        // max: labels.length + 1.0,
        categories: labels,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        minPadding: 2,
        title: {
          text: null,
        },
      },
    };
        setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handlePointsClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        ent: selectedFilter && selectedFilter.label,
        labels: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === JournalistWCRanking ||
        reportType === MediaWiseNOARanking ||
        reportType === ThematicAnalysisTag ||
        reportType === TonalityWCTrend ||
        reportType === ShareRetweet ||
        reportType === ReplyComment ||
        reportType === Attachment ||
        reportType === Like ||
        reportType === MemberType ||
        reportType === TypeOfPost ||
        reportType === TopPostersTrend ||
        reportType === InfluencerWithDetail
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_TREND ||
        reportType == REPORT_TYPES.SOV ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === TonalityWCTrend ||
        reportType === EditionWiseNOATrend ||
        reportType === TopPostersTrend ||
        reportType === InfluencerWithDetail ||
        twitterFeeds ||
        insightFeeds !== 0
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
        if (isEmbededWidget) {
          let labelArray = label.split("[");
          routeParams.sourceName = labelArray
            .slice(0, labelArray.length - 1)
            .join("[");
        }
      }
      if (reportType === JournalistWCRanking) {
        routeParams.sourceName = label;
      }
      if (reportType === JournalistAnalysisPrint) {
        routeParams.sourceName = clickedEntity;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType === ThematicAnalysisTag) {
        const clickedCategory = dataByReportType.filter(
          (elm) => elm.category_name == label
        )[0];
        routeParams.categoryId = clickedCategory.category_id;
      }
      if (reportType === ThematicAnalysisEntity) {
        const entityClicked = dataByReportType.filter(
          (elm) => elm.entity_name == label
        )[0];

        if (entityClicked && entityClicked.data && entityClicked.data.length) {
          const clickedCategory = entityClicked.data.filter(
            (elm) => elm.category_name == legend
          )[0];
          routeParams.categoryId = clickedCategory.category_id;
        }
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === EditionWiseNOATrend ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (reportType === MediaWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == label
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality ||
        reportType === TonalityWordCount ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channelType = getSocialPlatformIdFromName(label);
      }
      if (reportType == Reach) {
        routeParams.channelType = getSocialPlatformIdFromName(legend);
      }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      // routeParams.ent = selectedFilter && selectedFilter.label.toString();
      routeParams.labels = legend.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

LineChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
